import React, { Component } from 'react';
import videojs from 'video.js';

export default class ReactVideoPlayer extends Component {

  componentDidMount() {
    
    this.player = videojs(this.videoNode, this.props)
    
    this.props.handleChangePlayerObject(this.player);
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }
  render() {
    return (
        <div id="deluxe-video-player" data-video-id={this.props.videoId}>
          <video id="sub-deluxe-video-player" ref={ node => this.videoNode = node } className="video-js vjs-big-play-centered  vjs-default-skin"></video>
        </div>
    )
  }
}